/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flow_PurchaseInputs */

const en_flow_purchase = /** @type {(inputs: Flow_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A purchase`)
};

/**
* | output |
* | --- |
* | "A purchase" |
*
* @param {Flow_PurchaseInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const flow_purchase = /** @type {((inputs?: Flow_PurchaseInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flow_PurchaseInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_flow_purchase(inputs)
});